import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AcademicYearService } from 'src/app/private/services/acedemicyear.service';
import { BatchService } from 'src/app/private/services/batch.service';
import { CourseService } from 'src/app/private/services/course.service';
import { FeeService } from 'src/app/private/services/fee-service.service';
import { HostelService } from 'src/app/private/services/hostel.service';
import { ScholarshipService } from 'src/app/private/services/scholarship.service';
import { StudentService } from 'src/app/private/services/student.service';
import { TransportService } from 'src/app/private/services/transport.service';
import { UploadService } from 'src/app/private/services/upload.service';
import { UsersService } from 'src/app/private/services/users.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { StudentTempProfileMiddleScreenComponent } from "../student-temp-profile-middle-screen/student-temp-profile-middle-screen.component";
import { AdmissionService } from 'src/app/private/services/admission.service';
import { LeadService } from 'src/app/private/services/lead.service';

@Component({
  selector: 'app-student-temp-profile',
  imports: [SharedModule, StudentTempProfileMiddleScreenComponent],
  templateUrl: './student-temp-profile.component.html',
  styleUrl: './student-temp-profile.component.scss'
})
export class StudentTempProfileComponent {

  selectedTabIdx = 0;
  student_id: any = '';
  initialLoading = true;
  studentDetails: any = {};
  users: any = [];

  selectedStatus = '';
  selectedAcademicYear = '';
  selectedCourse = '';
  selectedBatch = '';
  loading = false;
  previewImage: string | null = null;

  editLeadData: any = {};

  studentStatusList: any[] = [
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' },
    { value: 'Graduated', label: 'Graduated' },
    { value: 'Suspended', label: 'Suspended' },
    { value: 'Withdrawn', label: 'Withdrawn' }
  ];

  selectedFeeCategory = '';
  selectedDepartment = '';

  selectedHostelCategory = '';
  selectedScholarshipType = '';
  selectedTransportRoute = '';

  allCourses: any[] = [];
  batchList: any[] = [];
  academicYearList: any[] = [];
  feeCategoryList: any[] = [];
  departmentList: any[] = [];

  hostelCategoryList: any[] = [];
  scholarshipTypeList: any[] = [];
  transportRouteList: any[] = [];

  student_profile_stage = 'registration';

  fullUser: any[] = [];


  enrollmentStatusList: any[] = [
    { value: 'Under Review', label: 'Under Review' },
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Canceled', label: 'Canceled' }
  ];



  documentStatusList = [
    { label: 'Verified', value: 'verified' },
    { label: 'Pending', value: 'pending' },
    { label: 'Rejected', value: 'rejected' }
  ];

  modeOfStudyList: any[] = [
    { label: 'Online', value: 'Online' },
    { label: 'Offline', value: 'Offline' },
    { label: 'Hybrid', value: 'Hybrid' }
  ];

  allLeadFeilds: any[] = [];



  applicationStatusList: any[] = [
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Canceled', label: 'Canceled' }
  ];


  registrationStatusList: any[] = [
    { value: 'Pending', label: 'Pending' },
    { value: 'Under Review', label: 'Under Review' },
    { value: 'Accepted', label: 'Accepted' },
    { value: 'Rejected', label: 'Rejected' }
  ];



  constructor(
    private messageService: MessageService,
    private route: ActivatedRoute,
    private api: StudentService,
    private localStorage: LocalStorageService,
    private userApi: UsersService,
    private academicYearApi: AcademicYearService,
    private batchApi: BatchService,
    private courseApi: CourseService,
    private uploadService: UploadService,
    private feeGroupApi: FeeService,
    private hostelApi: HostelService,
    private scholarshipApi: ScholarshipService,
    private transportApi: TransportService,
    private admissionApi: AdmissionService,
    private leadApi: LeadService
  ) {
    this.student_id = this.localStorage.getStudentId();
  }

  ngOnInit() {
    this.getStudentDetails();
    this.getAllUsers();
    this.getAllCourses();
    this.getAllAcademicYears();
    this.getAllBatches();
    this.getAllFeeCategories();
    this.getAllDepartments();
    this.getAllHostelCategories();
    this.getAllScholoarshipTypes();
    this.getAllTransportRoutes();
    this.getLeadsFields();
  }




  getLeadsFields() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      module_type: this.student_profile_stage || 'registration'
    };
    this.leadApi.getLeadsFields(param).subscribe({
      next: (data) => {
        this.allLeadFeilds = data?.fields.sort((a: any, b: any) => a.sequence - b.sequence);
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getStudentDetails() {
    if (!this.student_id) return;

    const payload = {
      uuid: this.student_id,
    };

    this.api.getStudentTempProfileByUUID(payload).subscribe({
      next: (res: any) => {

        let current_stage = res?.data?.current_stage || 'registration';
        this.student_profile_stage = current_stage;
        if (current_stage === 'registration') {
          this.studentDetails = {
            ...res?.data?.lead,
            ...res?.data?.registration
          }

          this.studentDetails.preferred_course =
            this.studentDetails?.preferred_course != null
              ? String(this.studentDetails.preferred_course)
              : null;

          console.log('Registration Stage Student Details:', this.studentDetails);
        } else if (current_stage === 'admission') {
          this.studentDetails = res?.data?.admission || {};
          this.selectedAcademicYear = this.studentDetails.academic_year_id || '';
          this.selectedCourse = this.studentDetails.course_id || '';
          this.selectedBatch = this.studentDetails.batch_id || '';
          this.selectedFeeCategory = this.studentDetails.fee_group_id || '';
          this.selectedDepartment = this.studentDetails.department_id || '';
          this.selectedHostelCategory = this.studentDetails.hostel_category || '';
          this.selectedScholarshipType = this.studentDetails.scholarship_id || '';
          this.selectedTransportRoute = this.studentDetails.transport_category || '';
        } else if (current_stage === 'enrollment') {
          this.studentDetails = {
            ...res?.data?.lead,
            ...res?.data?.enrollment
          }
          this.editLeadData = res?.data || {};
        } else if (current_stage === 'application') {
          this.studentDetails = {
            ...res?.data?.lead,
            ...res?.data?.registration,
            ...res?.data?.application
          }
        } else if (current_stage === 'registration') {
          this.studentDetails = {
            ...res?.data?.lead,
            ...res?.data?.registration
          }
        }

        // this.studentDetails = res?.data || {};
        this.initialLoading = false;
        console.log('Student Details:', this.studentDetails);
        this.loading = false;
      },
      error: (err: any) => {
        this.initialLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.message || 'Failed to load student details'
        });
      }
    });
  }

  getAllDepartments() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.userApi.getAllDepartment(param).subscribe({
      next: (data) => {
        this.departmentList = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }


  getAllUsers() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
    };
    this.userApi.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.users = res || [];
        this.fullUser = res || [];
        this.users = this.users.map((user: any) => {
          return {
            name: [user.prefix, user.fname, user.lname].filter((n: string) => !!n).join(' '),
            user_id: user.user_id
          };
        });
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }

  getAllCourses() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
    };
    this.courseApi.getAllCourses(param).subscribe({
      next: (data) => {
        this.allCourses = data || [];
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getAllAcademicYears() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };
    this.academicYearApi.getAllAcademicYears(param).subscribe({
      next: (data) => {
        this.academicYearList = data || [];
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getAllFeeCategories() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.feeGroupApi.getAllActiveFeeGroups(param).subscribe({
      next: (data) => {
        this.feeCategoryList = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  getAllBatches() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };
    this.batchApi.getAllBatches(param).subscribe({
      next: (data) => {
        this.batchList = data || [];
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getFullName() {
    return [this.studentDetails?.prefix, this.studentDetails?.first_name, this.studentDetails?.last_name]
      .filter(name => !!name)
      .join(' ');
  }

  handleCopy() {
    console.log('Copied');
    let email = this.studentDetails.email;
    navigator.clipboard.writeText(email);
    this.messageService.add({ severity: 'success', summary: 'Email copied', detail: 'Email copied to clipboard' });
  }


  getInitials() {
    const firstName = this.studentDetails?.first_name || '';
    const lastName = this.studentDetails?.last_name || '';
    return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
  }

  updateStudentField(field: string) {
    let updateData: any = {
      student_id: this.student_id,
      organization_id: this.localStorage.getOrganizationId()
    };

    switch (field) {
      case 'status':
        updateData.status = this.selectedStatus;
        break;
      case 'academic_year':
        updateData.academic_year = this.selectedAcademicYear;
        break;
      case 'course':
        updateData.course_id = this.selectedCourse;
        break;
      case 'batch':
        updateData.batch_id = this.selectedBatch;
        break;
    }

    this.api.updateStudent(updateData).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Student updated successfully'
        });
      },
      error: (err: any) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.message || 'Failed to update student'
        });
      }
    });
  }

  async onProfileImageUpload(event: Event): Promise<any> {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files[0]) {
      const file = input.files[0];

      // Show image immediately using FileReader
      const reader = new FileReader();

      reader.onload = async (e: ProgressEvent<FileReader>) => {
        const result = e.target?.result;
        if (typeof result === 'string') {
          this.previewImage = result;

          this.messageService.add({
            severity: 'info',
            summary: 'Info',
            detail: 'Uploading Image...',
          });

          console.log('Student Profile Stage:', this.student_profile_stage);


          if (this.student_profile_stage == 'admission') {
            this.updateStudentProfileAdmissionImage(file);
          }else if (this.student_profile_stage == 'enrollment' || this.student_profile_stage == 'application' || this.student_profile_stage == 'registration') {
            const imageUrl = await this.uploadToS3(file);
            this.updateLeadProfileImage(imageUrl);
          }

        }
      };

      reader.readAsDataURL(file);
    }
  }



  updateLeadProfileImage(imageUrl: string) {
    const payload = {
      lead_id: this.studentDetails.lead_id,
      organization_id: this.localStorage.getOrganizationId(),
      profile_pic: imageUrl,
      old_lead_data: {
        profile_pic: this.studentDetails.profile_pic
      },
      user : this.fullUser.find(user => user.user_id === this.studentDetails.user_id) || {},
      user_id : this.studentDetails.user_id
    };

    this.leadApi.updateLead(payload).subscribe({
      next: (response) => {
        console.log('Profile Image Updated:', response);
        this.messageService.clear();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Profile Image Updated Successfully'
        });
      },
      error: (error) => {
        console.error('Error:', error);
        this.messageService.clear('upload');
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Something went wrong'
        });
      }
    });
  }



  async updateStudentProfileAdmissionImage(file: File) {
    try {

      const imageUrl = await this.uploadToS3(file);

      const payload = {
        admission_id: this.studentDetails.admission_id,
        profile_pic: imageUrl,
        old_admission_data: {
          profile_pic: this.studentDetails.profile_pic
        }
      };

      this.admissionApi.updateAdmission(payload).subscribe({
        next: (response) => {
          console.log('Profile Image Updated:', response);
          this.messageService.clear();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Profile Image Updated Successfully'
          });
        },
        error: (error) => {
          console.error('Error:', error);
          this.messageService.clear('upload');
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Something went wrong'
          });
        }
      });
    } catch (error) {
      console.error('Upload failed:', error);
      this.messageService.clear('upload');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to upload image.'
      });
    }
  }


  async uploadToS3(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      const folder = `education/students/documents`;
      formData.append('file', file);
      formData.append('folders', folder);
      formData.append('bucket', 'global-upload-storage');

      this.uploadService.uploadDocuments(formData).subscribe({
        next: (response: any) => {
          console.log('File uploaded successfully:', response);
          resolve(response.url); // Assuming API returns { url: 's3-url' }
        },
        error: (error) => {
          console.error('Error uploading file:', error);
          reject('');
        },
      });
    });
  }

  updateStudentProfileImage(imageUrl: string) {
    const updateData = {
      student_id: this.student_id,
      organization_id: this.localStorage.getOrganizationId(),
      profile_pic: imageUrl
    };

    this.api.updateStudent(updateData).subscribe({
      next: (res: any) => {
        this.studentDetails.profile_pic = imageUrl;
        this.previewImage = null;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Profile image updated successfully'
        });
      },
      error: (err: any) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update profile image'
        });
      }
    });
  }

  handleCall() {
    // Implement call functionality
    console.log('Call student:', this.studentDetails);
  }

  handleWhatsapp() {
    // Implement WhatsApp functionality
    console.log('WhatsApp student:', this.studentDetails);
  }

  handleEmail() {
    // Implement email functionality
    console.log('Email student:', this.studentDetails);
  }

  handleBack() {
    console.log('Back');
  }


  handleSaveQuickActions() {

    const payload: any = {
      ...this.studentDetails,
      old_student_details: this.studentDetails,
      course_id: this.selectedCourse,
      academic_year_id: this.selectedAcademicYear,
      batch_id: this.selectedBatch,
      fee_group_id: this.selectedFeeCategory,
      user_id: this.localStorage.getUserId()
    };

    this.loading = true;
    this.api.updateStudent(payload).subscribe({
      next: (response) => {
        console.log('Update Student:', response);
        this.getStudentDetails();
      },
      error: (error) => {
        this.loading = false;
        console.log('Error:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
      }
    });

  }


  getAllHostelCategories() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.hostelApi.getAllHostelCategories(param).subscribe({
      next: (data) => {
        this.hostelCategoryList = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  getAllScholoarshipTypes() {

    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.scholarshipApi.getAllScholarships(param).subscribe({
      next: (data) => {
        this.scholarshipTypeList = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  getAllTransportRoutes() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.transportApi.getAllTransports(param).subscribe({
      next: (data) => {
        this.transportRouteList = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }


}

